import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface DeleteFileVars {
	tripId: string
	fileId: string
}

export function useDeleteFile() {
	const queryClient = useQueryClient()

	return useMutation<void, Error, DeleteFileVars>({
		mutationFn: async ({ tripId, fileId }) => {
			await api.delete(`/trips/${tripId}/files/${fileId}`)
		},
		onSuccess: (_data, { tripId }) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.files(tripId) })
		},
	})
}
